<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven">
        <div>
          <div class="title_div">
            <span class="title-span">发布日期:</span>

            <el-date-picker
              @change="dateChange"
              v-model="zwParams.rankingDate"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="copyAll"
              >批量导出
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="zwList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="memberName"
                label="客户姓名"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="memberMobile"
                label="客户电话"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="groupCount" label="组数" align="center">
              </el-table-column>
              <el-table-column
                prop="memberCreateBy"
                label="教练"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="rankingDate" label="日期" align="center">
                <template slot-scope="scope">{{
                  scope.row.rankingDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <!-- <el-table-column
                prop="address"
                label="操作"
                align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="medium" @click="edutDW(scope.row)">编辑</el-button>    
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="zwSizeChange"
              @current-change="zwCurrentChange"
              :current-page="zwResult.current"
              :page-size="zwResult.size"
              layout="total,prev, pager, next, sizes"
              :total="zwResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
        <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getGroupKingRanking,
  updateGroupKingRankingGroupCount,
  getGroupKingRankingForExcel,
} from "../../api/OperationManagement";

export default {
  name: "7GroupNumberList",
  data() {
    return {
      activeName: "seven",
      zwList: [],
      zwResult: {},
      zwParams: {
        rankingDate: "",
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getGroupKingRanking(this.zwParams);
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        // this.$router.push('/OperationManagement/7GroupNumberList');
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    //获取组王榜
    getGroupKingRanking(params) {
      getGroupKingRanking(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.zwResult = res.data.result;
            this.zwList = res.data.result.records;
          } else {
            this.zwResult = res.data.result;
            this.zwList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //查询时间更改
    dateChange() {
      this.zwParams.pageNo = 1;
      this.getGroupKingRanking(this.zwParams);
    },
    zwSizeChange(newSize) {
      this.zwParams.pageSize = newSize;
      this.getGroupKingRanking(this.zwParams);
    },
    zwCurrentChange(newPage) {
      this.zwParams.pageNo = newPage;
      this.getGroupKingRanking(this.zwParams);
    },
    //批量导出
    copyAll() {
      getGroupKingRankingForExcel(this.zwParams).then((res) => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = "组数王"; // sessionStorage.realName + timestr　　　　　　　　// xxx.xls/xxx.xlsx
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>
